import { render, staticRenderFns } from "./RegisterForEvent.vue?vue&type=template&id=8f983dd8&scoped=true"
import script from "./RegisterForEvent.vue?vue&type=script&lang=js"
export * from "./RegisterForEvent.vue?vue&type=script&lang=js"
import style0 from "./RegisterForEvent.vue?vue&type=style&index=0&id=8f983dd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f983dd8",
  null
  
)

export default component.exports